function manageSlideTabbing(swiper) {
    const slides = swiper.slides;
    for (slide of slides) {
        if (!slide.classList.contains('swiper-slide-visible')) {
            slide.setAttribute('tabindex', '-1');
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
        } else {
            slide.removeAttribute('tabindex');
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
        }
    }
};